import React, { useState } from "react";
import { Modal, Box, Typography, Button, List, ListItem } from "@mui/material";
import { useSelector } from "react-redux";

export default function AccountSwitcherModal({ open, onClose }) {
  const accounts = JSON.parse(localStorage.getItem("accounts")) || [];
    const switchAccount = useSelector((state)=>state.reducer.switchAccount);
  const handleSwitch = (account) => {
    // Set token for switched account
    sessionStorage.setItem("smbToken", account.token);

    // Set active account
    localStorage.setItem("activeAccount", account.mobile);

    // Reload app
    window.location.reload();
  };

  return (
    <Modal open={switchAccount} onClose={onClose}>
      <Box
        sx={{
          width: 400,
          bgcolor: "white",
          p: 3,
          borderRadius: 2,
          mx: "auto",
          mt: "10%",
        }}
      >
        <Typography variant="h6">Switch Account</Typography>

        <List>
          {accounts.map((acc, index) => (
            <ListItem key={index}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => handleSwitch(acc)}
              >
                {acc.mobile}
              </Button>
            </ListItem>
          ))}
        </List>

        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 2 }}
          onClick={() => {
            localStorage.removeItem("activeAccount");
            sessionStorage.clear();
            window.location.href = "/login";
          }}
        >
          + Add New Account
        </Button>
      </Box>
    </Modal>
  );
}
